import { z } from 'zod';

export const validationSchema = z.object({
  searchTerm: z.string(),
  from: z.date().optional(),
  to: z.date().optional(),
  showDeleted: z.boolean(),
});

export type FormValues = z.infer<typeof validationSchema>;

export const defaultValues: FormValues = {
  searchTerm: '',
  from: undefined,
  to: undefined,
  showDeleted: false,
};
